import React from 'react';
import PropTypes from 'prop-types';

import { NimbusAlert } from '../nimbus/nimbusAlert/nimbusAlert';
import './Alert.css';

export class Alert extends React.Component {

  render() {
    const {
      dismissible,
      onDismiss,
      dismissComponent,
      className, // additional classes you want to add
    } = this.props;

    return (
        <NimbusAlert
            className={'tdsAlert ' + this.props.type + ' ' + (className || '')}
            dismissible={dismissible} onDismiss={onDismiss}
            dismissComponent={dismissComponent} displayClass={'default'}>
          <i className="alert-icon"></i>{this.props.children}
        </NimbusAlert>
    );
  }
}

Alert.propTypes = {
  type: PropTypes.oneOf(['error', 'success', 'info', 'warning']),
  dismissible: PropTypes.bool,
  onDismiss: PropTypes.func,
  dismissComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

Alert.defaultProps = {
  type: 'info',
  dismissible: false,
};